import React, { Component } from 'react'
import Web3 from 'web3';
import ShopToken from './ShopToken'
import utils from '../../library'
import Icons from '../Icons/Icons'


import './cssPriceList1_0.css';


class PriceList1_0 extends Component {
 constructor(props){
     super()
     this.state={
         edit:true,
         items:[],
         box:"",
         boxindex:0,
         ticket:"",
         focus:"",
         loading:true
        }
 }

    componentDidMount() {
        this.loadItems()
    }

    async setNewPrice(){
        let addr=this.props.address
        await window.ethereum.enable().then(await async function (accounts) { 
            alert(addr)
            let priceListAddress = await utils.prices(addr)
            alert(priceListAddress)
            const prices = await utils.priceList(priceListAddress) 
            alert(prices)
                if(document.getElementById("PriceList_add_item_setprice_field").value!=""){
                    if(parseFloat(document.getElementById("PriceList_add_item_setprice_field").value)>=0.001){
                        await prices.methods.setPrice(document.getElementById("PriceList_add_item_setaddress_field").value,parseInt(parseFloat(document.getElementById("PriceList_add_item_setprice_field").value)*1000)).send({from: accounts[0] , gas: 323456 })
                    }else{
                        alert("SET A PRICE > 0.001")
                    }    
                }else{
                    alert("SET A TOKEN ADDRESS IN ORDER TO ADD A TOKEN TO THE SHOP!")
                }
        })
        this.loadItems()  
    }

    async loadItems() {
        let total_listing=[]
        let addr=this.props.address
        let priceListz
        let box
        await window.ethereum.enable().then(async function (accounts) {
            let account=accounts[0];
            try{
                priceListz = await utils.prices(addr)
                const prices = await utils.priceList(priceListz) 
                box = await utils.ticket2Box(addr)
                let index = await prices.methods.priceListing(0).call()
                console.log("index",index)
                for(let i=0;i<parseInt(index[2]);i++){
                    if(((utils.getUrlVars()["index"]!="")&&(i==utils.getUrlVars()["index"]))||(!utils.getUrlVars()["index"])){  
                        let item = await prices.methods.priceListing(i).call()
                        try{               
                            let name = await utils.totalSupply(item[0])
                            let a=[]
                            a.push(item)
                            a.push(name)
                            total_listing.push(a)
                        }catch(e){}  
                    }
                }
                console.log("LOADED ITEMS "+total_listing)
            }catch(e){console.log("PriceList loadItems()",e)}
        })
        this.setState({items : total_listing,priceList : priceListz,focus : addr,box : box,loading:false})
        try{this.props.setAmount(total_listing.length)}catch(e){} 
        if(!utils.getUrlVars()["shop"])this.loadMeta(addr)
    }

    async checkAddress(){
       
            await window.ethereum.enable().then(async function (accounts) {
                let account=accounts[0];
                try{
                let addr=document.getElementById("PriceList_add_item_setaddress_field").value
                if(addr.indexOf("/")>0)addr=web3.utils.toHex(addr.substring(addr.indexOf("/")+1))
                let symbol = await utils.symbolOf(addr)
                document.getElementById("address_to_sell").innerHTML=symbol
                document.getElementById("address_to_sell").style.color='white'
                }catch(e){
                    document.getElementById("address_to_sell").style.color='red'
                    document.getElementById("address_to_sell").innerHTML="address"
                }
            })
    }

    async loadMeta(list){
  
        let addr=list
   
        await window.ethereum.enable().then(async function (accounts) {
            let metafound=false
            let mtdt   
            mtdt=await utils.metadata(addr,addr)
       
            if(mtdt.length>0){
                
                console.log("MTDT",mtdt)
                fetch(utils.formatURL(mtdt)).then(response => response.json()).then(
                response => {
                    console.log(JSON.stringify(response))
                    
                    let back=response[0]["image"]
                    if(back=="")back='https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE'
                    //document.getElementById("PriceList_shop_link"+this.state.focus).appendChild()
                    document.getElementById("PriceList_mini_banner_"+addr).style.backgroundImage='url('+back+')'
                    document.getElementById("PriceList_mini_banner_"+addr).style.border="solid 1px white"
                })
            }else{
                try{
                document.getElementById("PriceList_shop_link_"+addr).style.width="50px"
                document.getElementById("PriceList_shop_link_"+addr).innerHTML="🛒"
                }catch(e){}
            }

        })
    
}

editMode(){
    (!this.state.edit)?this.setState({edit:true}):this.setState({edit:false})
}

    render(){
    const final = [];
    let n=0;
    console.log("PRICELIST STATE",this.state)
    if(this.props.address!=this.state.focus)this.loadItems()
    for (let  itm of this.state.items) { 
        if(utils.getUrlVars()["shop"]>0){
        final.push(<ShopToken db={this.state.box} priceList={this.state.priceList} address={itm[0][0]} price={itm[0][1]} index={this.props.address+"x"+n} ticket={this.props.address} key={n} edit={this.props.edit} name={itm[1]}></ShopToken>);
        }else{
        final.push(<ShopToken db={this.state.box} priceList={this.state.priceList} address={itm[0][0]} price={itm[0][1]} index={this.props.address+"x"+n} ticket={this.props.address} key={n} edit={this.state.edit} name={itm[1]}></ShopToken>);
        }
        n++
    }
        return ( 
                <div className="PriceList_module_main">
                  {
                (this.state.loading)?<center><img className="loadergif" id="pricelist_loadergif" src="https://androidexample365.com/content/images/2019/07/rainbow_ring.gif"></img></center>:<></>
                }
                {(final.length>0)?
                <div>
                <div className="PriceList_module_item_row">
                    <div className="PriceList_module_link_panel dark darkblue">
                    {(!utils.getUrlVars()["shop"])?<span id="PriceList_settings" className={(this.state.edit)?"PriceList_settings_editing":"PriceList_settings"} onClick={() => this.editMode()}><Icons icon="settings" d="50"/></span>:<></>}
                    
                    {(!utils.getUrlVars()["shop"])?<span className="Price_list_label" onClick={() => window.open("https://ropsten.etherscan.io/address/"+this.state.focus)}><Icons icon="ticket" d="60"/>  <div className="PriceList_label_top"> #{this.props.index}</div></span>:<span className="Price_list_label"><div  className="PriceList_ticket_link" onClick={() => window.open("https://ropsten.etherscan.io/address/"+this.state.focus)}><Icons icon="ticket" d="60"/></div></span>}
                    {(!utils.getUrlVars()["shop"])?<span id={"PriceList_shop_link_"+this.state.focus} className="PriceList_module_link_icon right" onClick={() => utils.jump(this.state.focus)}><div id={"PriceList_mini_banner_"+this.state.focus} className="PriceList_mini_banner"></div> </span>:<></>}
                    <div className="PriceList_box_link_holder">
                            <span className="PriceList_module_link_icon right" onClick={() => utils.jumpBox(this.state.box)}><Icons icon="box" d="50"/></span>
                            <span className="PriceList_module_link_icon right" onClick={() => utils.copyBoxAddress(this.state.box)}><Icons icon="copy" d="50"/></span>
                    </div> 
                        </div>       
                </div>
                <div id="PriceList_container_box">
                    <div id="PriceList_finalContainer" className="PriceList_finalContainer light lightblue">
                        {final}
                        <div className="clear"></div>
                    </div>
                </div>
                </div>
                :
                <>
                {(this.props.edit)?<div className="PriceList_empty_message">#{this.props.index} sell something!</div>:<></>}
                {(this.props.edit)?
                <div className="PriceList_module_item_row">
                    <div className="PriceList_module_link_panel dark darkblue">
                    {(!utils.getUrlVars()["shop"])?<span className="Price_list_label" onClick={() => window.open("https://ropsten.etherscan.io/address/"+this.state.focus)}><Icons icon="ticket" d="60"/><div className="PriceList_label_top"> #{this.props.index}</div></span>:<span className="Price_list_label"><div className="PriceList_ticket_link" onClick={() => window.open("https://ropsten.etherscan.io/address/"+this.state.focus)}><Icons icon="box" d="60"/></div></span>}
                    {(!utils.getUrlVars()["shop"])?<span  id={"PriceList_shop_link_"+this.state.focus} className="PriceList_module_link_icon right" onClick={() => utils.jump(this.state.focus)}><div id={"PriceList_mini_banner_"+this.state.focus} className="PriceList_mini_banner"></div></span>:<></>}
                    <div className="PriceList_box_link_holder">
                            <span className="PriceList_module_link_icon right" onClick={() => utils.jumpBox(this.state.box)}><Icons icon="box" d="60"/></span>
                            <span className="PriceList_module_link_icon right" onClick={() => utils.copyBoxAddress(this.state.box)}><Icons icon="copy" d="60"/></span>
                        </div> 
                    </div>       
                </div>:
                <></>}
                </>
                }
                {(this.props.edit)?
                <div>
                <div className="PriceList_add_item_row">
                    <div className="PriceList_add_item_panel dark darkblue text white">
                            <img id="PriceList_add_item_icon" src="https://i.imgur.com/YKhumij.png"></img>
                            <div className="PriceList_item_setprice light lightblue">
                                <input id="PriceList_add_item_setaddress_field" className="PriceList_item_setprice_field light lightblue text white" type="text" onKeyUp={() => this.checkAddress()} onKeyPress={() => this.checkAddress()}></input>
                                <span id="address_to_sell" className="right paddingright">address</span>
                            </div>
                            <div className="PriceList_item_setprice light lightblue">
                                <input id="PriceList_add_item_setprice_field" className="PriceList_add_item_setprice_field light lightblue text white" type="text"></input>
                                <div className="PriceList_item_setprice_button dark darkblue text white" value="" onClick={() => this.setNewPrice()}><Icons icon="pen" d="40"/><div className="button_label_right">set price!</div></div>
                            </div>
                    </div>
                </div>
                </div>:
                    <div></div>
                    }            
        </div>
        );
    }
}










const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")

export default PriceList1_0